import React from 'react'
import { Intent } from '@blueprintjs/core'
import { Button } from '@ui'
import { IFloorMapSpace } from '@api/types'
// import {
//   useDepartmentSearch,
//   DepartmentItem,
// } from '@ui/selects/_DepartmentSelect'
import { get } from 'lodash'
import { IDepartment } from '@api'

interface DepartmentTabProps {
  space?: IFloorMapSpace
  spaces?: IFloorMapSpace[]
  allocate: (toDepartment: IDepartment | null) => void
}

export default function DepartmentTab({ space, spaces, allocate }: DepartmentTabProps) {
  const hasAllocation = space
    ? !!get(space, 'spaceAssignment.department')
    : spaces && spaces.some(({ spaceAssignment }) => get(spaceAssignment, 'department'))

  return (
    <div style={{ margin: '-10px -5px' }}>
      {hasAllocation && (
        <div style={{ margin: '5px' }}>
          <Button
            fill
            minimal
            ghost
            intent={Intent.DANGER}
            iconName="times"
            text="Unallocate"
            onClick={() => allocate(null)}
          />
        </div>
      )}
      <div style={{ height: hasAllocation ? 250 : 287 }}>
        TODO
        {/* <DepartmentList {...{ space, spaces, allocate }} /> */}
      </div>
    </div>
  )
}

// function DepartmentList({ space, spaces, allocate }: DepartmentTabProps) {
//   let search = useDepartmentSearch()

//   return (
//     <Downshift
//       itemToString={() => ''}
//       onSelect={department => {
//         allocate && allocate(department)
//       }}>
//       {({ getInputProps, getMenuProps, getItemProps, highlightedIndex }) => (
//         <div
//           style={{
//             height: '100% ',
//             position: 'relative',
//             overflowY: 'auto',
//             borderRadius: 4,
//             width: 280,
//           }}>
//           <div
//             style={{
//               position: 'sticky',
//               top: 0,
//               padding: 5,
//               paddingBottom: 0,
//               background: 'white',
//               zIndex: 1,
//             }}>
//             {/*
//             // @ts-ignore */}
//             <InputGroup
//               {...getInputProps({
//                 autoFocus: true,
//                 className: Classes.FILL,
//                 value: search.query,
//                 onChange: ({
//                   currentTarget: { value },
//                 }: React.FormEvent<HTMLInputElement>) => {
//                   search.run(value)
//                 },
//                 placeholder: 'Search...',
//                 leftIcon: <Icon name="search" />,
//                 onFocus: ({
//                   currentTarget,
//                 }: React.FormEvent<HTMLInputElement>) => {
//                   currentTarget.select()
//                 },
//                 style: { marginBottom: 5 },
//               })}
//             />
//           </div>
//           <div {...getMenuProps()}>
//             <Menu>
//               {!search.results.length && (
//                 <MenuItem disabled text="No results" />
//               )}
//               {}
//               {search.results.map((d, i) => (
//                 <MenuItem
//                   {...getItemProps({
//                     key: d.id,
//                     item: d,
//                   })}
//                   active={i === highlightedIndex}
//                   text={<DepartmentItem {...d} query={search.query} />}
//                 />
//               ))}
//             </Menu>
//           </div>
//         </div>
//       )}
//     </Downshift>
//   )
// }
